module.exports = __webpack_public_path__ + "static/media/skyminer_8.ea9596ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPage/images/skyminer_8.png
// module id = 1521
// module chunks = 0